import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

const BORDER = "#E2E6EC";
const BORDER_HOVER = "#C3CAD4";

export const MuiInputBase = {
  styleOverrides: {
    root: {
      fontSize: "0.9rem",
    },
  },
} satisfies Components<Theme>["MuiInputBase"];

export const MuiOutlinedInput = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: "#FFFFFF",
      borderRadius: 10,
      transition:
        "box-shadow 140ms ease, border-color 140ms ease, background-color 140ms ease",
      [`& .MuiOutlinedInput-notchedOutline`]: {
        borderColor: BORDER,
        transition: "border-color 140ms ease",
      },
      "&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline":
        {
          borderColor: BORDER_HOVER,
        },
      "&.Mui-focused": {
        backgroundColor: "#FFFFFF",
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}22`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderWidth: 1.5,
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.background.level1,
      },
    }),
    input: {
      padding: "12px 14px",
      "&::placeholder": { opacity: 0.7 },
    },
    inputSizeSmall: {
      padding: "9px 12px",
    },
  },
} satisfies Components<Theme>["MuiOutlinedInput"];

export const MuiInputLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      "&.Mui-focused": { color: theme.palette.primary.main },
    }),
  },
} satisfies Components<Theme>["MuiInputLabel"];

export const MuiTextField = {
  defaultProps: {
    variant: "outlined" as const,
  },
} satisfies Components<Theme>["MuiTextField"];

export const MuiFormControl = {
  styleOverrides: {
    root: {
      // keep consistent rounded look for Select/etc.
    },
  },
} satisfies Components<Theme>["MuiFormControl"];

export const MuiSelect = {
  styleOverrides: {
    root: {
      borderRadius: 10,
      backgroundColor: "#FFFFFF",
    },
  },
} satisfies Components<Theme>["MuiSelect"];
